const website = {
  name: '鉅亨網',
  appleStoreUrl: 'https://apps.apple.com/tw/app/%E9%89%85%E4%BA%A8%E7%B6%B2-cnyes/id1071014509',
  appleStoreId: '1071014509',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.cnyes.android',
  playStoreId: 'com.cnyes.android'
};

export default website;
